/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassstudentClassstudentidChannelsChannelid200,
  PutApiV1ClassstudentClassstudentidChannelsChannelid400,
  PutApiV1ClassstudentClassstudentidChannelsChannelid401,
  PutApiV1ClassstudentClassstudentidChannelsChannelid404,
  PutApiV1ClassstudentClassstudentidChannelsChannelid500,
  PutApiV1ClassstudentClassstudentidChannelsChannelidMutationRequest,
  PutApiV1ClassstudentClassstudentidChannelsChannelidMutationResponse,
  PutApiV1ClassstudentClassstudentidChannelsChannelidPathParams,
} from "../../types/classStudentChannelsController/PutApiV1ClassstudentClassstudentidChannelsChannelid.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";
import { upsertChannelRequestViewModelSchema } from "../upsertChannelRequestViewModelSchema.ts";

export const putApiV1ClassstudentClassstudentidChannelsChannelidPathParamsSchema =
  z.object({
    classStudentId: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1ClassstudentClassstudentidChannelsChannelid200Schema =
  z.lazy(
    () => channelDetailViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassstudentClassstudentidChannelsChannelid400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassstudentClassstudentidChannelsChannelid401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassstudentClassstudentidChannelsChannelid404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ClassstudentClassstudentidChannelsChannelid500Schema =
  z.any() as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelid500>;

export const putApiV1ClassstudentClassstudentidChannelsChannelidMutationRequestSchema =
  z.lazy(
    () => upsertChannelRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelidMutationRequest>;

export const putApiV1ClassstudentClassstudentidChannelsChannelidMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassstudentClassstudentidChannelsChannelid200Schema,
  ) as unknown as ToZod<PutApiV1ClassstudentClassstudentidChannelsChannelidMutationResponse>;
